import '../../globas.scss'

const PrivacyPolicy = () => {
    return (
<div>
    <h1>Privacy Policy</h1>
    <h3>Effective Date: 29/03/2025</h3>
    <h2>Introduction &amp; Organizational Info:</h2>
    <p>We, at Léon Zeitler, are dedicated to serving our customers and contacts to the best of our
        abilities. Part of our commitment involves the responsible management of personal information collected through
        our website www.leonzeitler.com, and any related interactions. Our primary goals in processing
        this information include:</p>
    <ul>
        <li>
            <p>Enhancing the user experience.</p>
        </li>
        <li>
            <p>Conducting necessary business operations.</p>
        </li>
    </ul>
    <p>It is our policy to process personal information with the utmost respect for privacy and security. We adhere to
        all relevant regulations and guidelines to ensure that the data we handle is protected against unauthorized
        access, disclosure, alteration, and destruction. Our practices are designed to safeguard the confidentiality and
        integrity of your personal information, while enabling us to deliver the services you trust us with.</p>
    <ul>
        <li>
                        <p>We do not have a designated Data Protection Officer (DPO) but remain
                fully committed to addressing your privacy concerns. Should you have any questions or require further
                information about how we manage personal information, please feel free to contact us at
                contact@leonzeitler.com.</p>
                    </li>
    </ul>
    <p>Your privacy is our priority. We are committed to processing your personal information transparently and with
        your safety in mind. This commitment extends to our collaboration with third-party services that may process
        personal information on our behalf, such as in the case of sending invoices. Rest assured, all activities are
        conducted in strict compliance with applicable privacy laws.</p>
    <br></br>
    <h2>Scope and Application:</h2>
    <p>Our privacy policy is designed to protect the personal information of all our stakeholders, including website
        visitors, registered users, and customers. Whether you are just browsing our website
        www.leonzeitler.com, using our services as a registered user, or engaging with us as a valued
        customer, we ensure that your personal data is processed with the highest standards of privacy and security.
        This policy outlines our practices and your rights related to personal information.</p>
        <br></br>
    <h2>Data Storage and Protection:</h2>
    <h3>Data Storage:</h3>
    <ul>
        <li>Personal information is stored in secure servers located in the following locations:
            Europe. For services that require international data transfer, we ensure
            that such transfers comply with all applicable laws and maintain data protection standards equivalent to
            those in our primary location.</li>
        <li>Data Hosting Partners: We partner with reputable data hosting providers committed to using state-of-the-art
            security measures. These partners are selected based on their adherence to stringent data protection
            standards.</li>
    </ul>
        <br></br>
        <h2>Data Processing Agreements:</h2>
    <p>When we share your data with third-party service providers, we do so under the protection of Data Processing
        Agreements (DPAs) that ensure your information is managed in accordance with GDPR and other relevant data
        protection laws. These agreements mandate that third parties implement adequate technical and organizational
        measures to ensure the security of your data.</p>
    <h3>Transparency and Control:</h3>
    <p>We believe in transparency and providing you with control over your personal information. You will always be
        informed about any significant changes to our sharing practices, and where applicable, you will have the option
        to consent to such changes.</p>
    <p>Your trust is important to us, and we strive to ensure that your personal information is disclosed only in
        accordance with this policy and when there is a justified reason to do so. For any queries or concerns about how
        we share and disclose personal information, please reach out to us at contact@leonzeitler.com.</p>
    <br></br>
    <h2>User Rights and Choices:</h2>
    <p>At Léon Zeitler, we recognize and respect your rights regarding your personal information,
        in accordance with the General Data Protection Regulation (GDPR) and other applicable data protection laws. We
        are committed to ensuring you can exercise your rights effectively. Below is an overview of your rights and how
        you can exercise them:</p>
    <p>Your Rights:</p>
    <ul>
        <li>
            <p>Right of Access (Article 15 GDPR): You have the right to request access to the personal information we
                hold about you and to obtain information about how we process it.</p>
        </li>
        <li>
            <p>Right to Rectification (Article 16 GDPR): If you believe that any personal information we hold about you
                is incorrect or incomplete, you have the right to request its correction or completion.</p>
        </li>
        <li>
            <p>Right to Erasure (‘Right to be Forgotten’) (Article 17 GDPR): You have the right to request the deletion
                of your personal information when it is no longer necessary for the purposes for which it was collected,
                among other circumstances.</p>
        </li>
        <li>
            <p>Right to Restriction of Processing (Article 18 GDPR): You have the right to request that we restrict the
                processing of your personal information under certain conditions.</p>
        </li>
        <li>
            <p>Right to Data Portability (Article 20 GDPR): You have the right to receive your personal information in a
                structured, commonly used, and machine-readable format and to transmit those data to another controller.
            </p>
        </li>
        <li>
            <p>Right to Object (Article 21 GDPR): You have the right to object to the processing of your personal
                information, under certain conditions, including processing for direct marketing.</p>
        </li>
        <li>
            <p>Right to Withdraw Consent (Article 7(3) GDPR): Where the processing of your personal information is based
                on your consent, you have the right to withdraw that consent at any time without affecting the
                lawfulness of processing based on consent before its withdrawal.</p>
        </li>
        <li>
            <p>Right to Lodge a Complaint (Article 77 GDPR): You have the right to lodge a complaint with a supervisory
                authority if you believe our processing of your personal information violates applicable data protection
                laws.</p>
        </li>
    </ul>
    <h3>Exercising Your Rights:</h3>
    <p>To exercise any of these rights, please contact us at contact@leonzeitler.com. We will respond to your request in accordance with applicable data
        protection laws and within the timeframes stipulated by those laws. Please note, in some cases, we may need to
        verify your identity as part of the process to ensure the security of your personal information.</p>
    <p>We are committed to facilitating the exercise of your rights and to ensuring you have full control over your
        personal information. If you have any questions or concerns about how your personal information is handled,
        please do not hesitate to get in touch with us.</p>
    <br></br>
            <h2>Cookies and Tracking Technologies:</h2>
            <p>At Léon Zeitler, we value your privacy and are committed to being transparent about our use
                of cookies and other tracking technologies on our website www.leonzeitler.com. These
                technologies play a crucial role in ensuring the smooth operation of our digital platforms, enhancing your user
                experience, and providing insights that help us improve.</p>
            <h3>Understanding Cookies and Tracking Technologies:</h3>
            <p>Cookies are small data files placed on your device that enable us to remember your preferences and collect
                information about your website usage. Tracking technologies, such as web beacons and pixel tags, help us
                understand how you interact with our site and which pages you visit.</p>
            <h3>How We Use These Technologies:</h3>
            <ul>
                <li>
                    <p>Essential Cookies: Necessary for the website's functionality, such as authentication and security. They
                        do not require consent.</p>
                </li>
            </ul>
            <h3>Changes to Our Cookie Use:</h3>
            <p>We may update our use of cookies and tracking technologies to improve our services or comply with legal
                requirements. We will notify you of any significant changes and seek your consent where necessary.</p>
            <p>For more detailed information about the cookies we use, their purposes, and how you can manage your preferences,
                please visit our detailed Cookie Policy null.</p>
            <p>Should you have any questions or concerns about our use of cookies and tracking technologies, please do not
                hesitate to contact us at contact@leonzeitler.com. Your
                privacy and the integrity of your personal data are of utmost importance to us.</p>
                    </div>
    )
} 

export default PrivacyPolicy